/**
 * @param  {} aId
 * @param  {} aDisplayOptions
 * @param  {} aOptions
 * wrapper for fullcalendar.js - adds support for schedules and color coding, also adds support for reocurring schedules.
 * @example
 *  mEnrolleesControls.carveOutSchedule = new VeritracksFullCalendarWrapper('#uCarveOutDesignSchedules',
    {
        "defaultView": "agendaWeek",
        "slotEventOverlap": false,
        "selectOverlap": true,
        "multiDaySelect": true,
        "displayEventEnd": true,
        "editable": true,
        "aspectRatio": 1.64,
        "selectable": true,
        "pastSelectable": false,
        "selectHelper": false,
        "selectMultiDay": false,
        "allDaySlot": true,
        "navLinks": true,
        "lazyFetching": true,
        "rightClickOptions": 'agendaWeek,agendaDay,listWeek',
        "leftClickOptions": 'prev,next, today',
        "nowIndicator": true
    },
    {
        'selectEventHandler': CarveOutSchedule_SelectHandler,
        'selectAllowHandler': CarveOutSchedule_SelectAllowHandler,
        'clickHandler': carveOutSchedule_ClickHandler,
        'afterRender': carveOutSchedule_AfterRender,
        'eventDrop': carveOutSchedule_ResizeOverEventDrop,
        'eventDragStop': carveOut_drapStopHelper,
        'resized': carveOutSchedule_Resized,
        'renderHandler': CarveOutSchedule_RenderHandler,
        "viewRender": carveOutSchedule_ViewRender,
        "afterAllRender": carveOutSchedule_AfterAllRender
    });

    mEnrolleesControls.carveOutSchedule.setView('agendaDay');
    mEnrolleesControls.carveOutSchedule.setView('agendaWeek');

    mEnrolleesControls.carveOutSchedule.setDataSource(lSchedules);
 */
/**
 * Used in CarveOut.js, Sobertrack - 2nd.js SoberTrack.js,Enrollees.js
 */

function VeritracksFullCalendarWrapper(aId, aDisplayOptions, aOptions) {
    var calendarId = aId;
    var mDataSource = null;
    var mEditingSchedule = null;
    var mEditType = -1;
    var mClickHandler = null;
    var mRightClickHandler = null;
    var dayStart = null;
    var mViewRenderHandler = null;
    var mAfterRenderHandler = null;
    var mAfterAllRenderHandler = null;
    var mViewEditMode = null;
    var mViewSelect = null;
    var mViewDragDrop = null;
    var mViewDragStop = null; 
    var mViewEvents = null;
    var mNewSelectEvents = null; 
    var mSpecialLayout = null;
    var mRenderHandler = null;
    var mResizeOver = null;
    var mResized = null;
    var mHideTitleFor = aDisplayOptions.hideTitleFor;
    var lockSave = false;
    var extraData = {};
    var invertColorsSet = false;
    var invertColorsClass = 'ColorInvert';
    var mDisableNavigation;
    var mSelectEventHandler = null;
    var mSelectAllowEventHandler = null;
    // handles calendar events

    if (aOptions) {
        if (aOptions.clickHandler) {
            mClickHandler = aOptions.clickHandler;
        }
        if (aOptions.rightClickHandler) {
            mRightClickHandler = aOptions.rightClickHandler;
        }
        if (aOptions.viewRender) {
            mViewRenderHandler = aOptions.viewRender;
        }
        if (aOptions.afterRender) {
            mAfterRenderHandler = aOptions.afterRender;
        }
        if (aOptions.afterAllRender) {
            mAfterAllRenderHandler = aOptions.afterAllRender;
        }
        if (aOptions.editMode) {
            mViewEditMode = aOptions.editMode;
        }
        if (aOptions.selected) {
            mViewSelect = aOptions.selected;
        }
        if (aOptions.eventDrop) {
            mViewDragDrop = aOptions.eventDrop;
        }
        if (aOptions.eventDragStop) {
            mViewDragStop = aOptions.eventDragStop;
        }
        if (aOptions.events) {
            mViewEvents = aOptions.events;
        }
        if (aOptions.newSelect) {
            mNewSelectEvents = aOptions.newSelect; 
        }
        if (aOptions.specialEventLayout) {
            mSpecialLayout = aOptions.specialEventLayout;
        }
        if (aOptions.renderHandler) {
            mRenderHandler = aOptions.renderHandler;
        }
        if (aOptions.resizeOver) {
            mResizeOver = aOptions.resizeOver;
        }
        if (aOptions.resized) {
            mResized = aOptions.resized;
        }
        if (aOptions.disabledNavigation) {
            mDisableNavigation = aOptions.disabledNavigation;
        }
        if (aOptions.selectEventHandler) {
            mSelectEventHandler = aOptions.selectEventHandler;
        }
        if (aOptions.selectAllowHandler) {
            mSelectAllowEventHandler = aOptions.selectAllowHandler;
        }
    }
    var veritracksCalendar = $(calendarId).fullCalendar({
        nowIndicator: aDisplayOptions.nowIndicator || false,
        defaultView: aDisplayOptions.defaultView,
        slotEventOverlap: aDisplayOptions.slotEventOverlap,
        selectOverlap: aDisplayOptions.selectOverlap,
        multiDaySelect: aDisplayOptions.multiDaySelect,
        displayEventEnd: aDisplayOptions.displayEventEnd,
        eventDurationEditable: aDisplayOptions.eventDurationEditable,
        editable: aDisplayOptions.editable,
        pastSelectable: aDisplayOptions.pastSelectable,
        aspectRatio: aDisplayOptions.aspectRatio,
        selectable: aDisplayOptions.selectable,
        selectHelper: aDisplayOptions.selectHelper,
        selectMultiDay: aDisplayOptions.selectMultiDay,
        allDaySlot: aDisplayOptions.allDaySlot,
        defaultDate: aDisplayOptions.DefaultDate,
        firstDay: aDisplayOptions.dayStart,
        lazyFetching: aDisplayOptions.lazyFetching,
        navLinks: aDisplayOptions.navLinks,
        slotDuration: '00:30:00',
        timeFormat: 'h:mma',
        customButtons: {
            previousDay: {
                text: 'prev',
                icon: 'left-single-arrow',
                click: function () {
                    toggleNav('prev');
                }
            },
            nextDay: {
                text: 'next',
                icon: 'right-single-arrow',
                click: function() {
                    toggleNav('next');
                }
            },
            todayDate: {
                text: 'today',
                click: function() {
                    toggleNav('today');
                }
            }
        },
        header: {
            left: 'previousDay,nextDay, todayDate',
            center: 'title',
            right: aDisplayOptions.rightClickOptions
        },
        views: {
            agendaMonthDay: {
                type: 'agenda',
                duration: { days: 31 },
                buttonText: '31 Days'
            }
        },
        events: function (event, jsEvent, timezone, callback) {
            disableCalendarNavigation(true);
            calendar_handleEvents(event, jsEvent, timezone, callback);
        },
        viewRender: function (view, element) {
            if (!isNullOrUndefined(veritracksCalendar)) {
                CloseModal();
                calendar_handleViewRender(view);
            }
        },
        eventRender: function (event, element) {
            calendarRender_handler(event);
            calendar_handleAfterRender(event, element);
            disableCalendarNavigation(false);
        },
        eventClick: function (calEvent, jsEvent, view) {
            calendar_handleClick(calEvent, jsEvent);
        },
        eventResize: function (event, delta, revertFunc, jsEvent) {
            cal_eventResized(event, delta, revertFunc, jsEvent);
            veritracksCalendar.fullCalendar('unselect');
        },
        eventResizeStop: function (event, jsEvent, ui, view)
        {
            cal_eventResizeStop(event, jsEvent, ui, view);
            veritracksCalendar.fullCalendar('unselect');
        },
        eventDragStart: function( event, jsEvent, ui, view) {
            //console.log(event);
        },
        eventDragOver: function (component, event, eArguments) {           
            calendar_dragEndEvent(component, event, eArguments);
        },
        eventDragStop: function (event, dayDelta, minuteDelta, allDay, revertFunc) {            
            cal_eventDragStop(event, dayDelta, minuteDelta, allDay, revertFunc);
            veritracksCalendar.fullCalendar('unselect');
        },
        eventDrop: function (event, delta, revertFunc, jsEvent, ui, view) {
            //stop 204 remove guide when dropped
            $('div[class|="fc-slats"').find('tr').map(function (key, el) {
                $(el).removeClass('uCarveOutSelectedDragedItem');
            });
            cal_eventDrop(event, delta, revertFunc, jsEvent, ui, view);
            veritracksCalendar.fullCalendar('unselect');
        },
        eventAfterAllRender: function (view) {
            if (mEditType >= 0) {
                calendar_handleEditMode();
                mEditType = -1;
            }
            if (invertColorsSet)
                colorInverter(invertColorsSet, invertColorsClass);

            if (mHideTitleFor && veritracksCalendar && mHideTitleFor == veritracksCalendar.fullCalendar('getView').name)
                $('.fc-content').addClass('fc-content-hide');


            calendar_handleAfterAllRender();
        },
        selectAllow: function (selectInfo) {
            if (!mSelectAllowEventHandler) return true;
            return mSelectAllowEventHandler(selectInfo);
        },
        select: function (aStart, aEnd, aEvent, aView,aResource) {
            if (aDisplayOptions.editable) {
                if (mSelectEventHandler) {
                    mSelectEventHandler(aStart, aEnd, aEvent, aView,aResource);
                } else {
                    veritracksCalendar.fullCalendar('renderEvent', specialEventHandler(aStart, aEnd,aEvent),
                        true // make the event "stick"
                    );
                }
            }

            calendar_handleSelect(aStart, aEnd, -1, true, true);
            veritracksCalendar.fullCalendar('unselect');
        },
        dayClick: function (date, event, view) {
            veritracksCalendar.fullCalendar('unselect');
        },
        newSelect: function (aStart, aEnd, allDay) {
            
            calendar_selectEvents(aStart, aEnd, allDay);
        },
    });

    function calendar_dragEndEvent(component, event, eArguments) {      
        $('div[class|="fc-slats"').find('tr').map(function (key, el) {

            if (!isNullOrUndefined(component) || !isNullOrUndefined($(el).offset())) {
                if (component.top - $(el).offset().top == 0 || (component.top - $(el).offset().top <= 17 && component.top - $(el).offset().top > 0)) {
                    $(el).addClass('uCarveOutSelectedDragedItem');
                } else {
                    $(el).removeClass('uCarveOutSelectedDragedItem');
                }
            }           
       }); 
    }

    function toggleNav(action) {
        if (!action) return;
        $(aId).fullCalendar(action);
        $(aId).fullCalendar('option', 'locale', 'en');
        $(aId).fullCalendar('option', 'locale', 'en');
    }
    function calendar_handleEvents(event, jsEvent, timezone, callback) {
        if (mViewEvents) {
            mViewEvents(event, jsEvent, timezone, callback);
        }
    }

    function calendar_selectEvents(aStart, aEnd, allDay) {
        if (mNewSelectEvents) {
            mNewSelectEvents(aStart, aEnd, allDay);
        }
    }

    function calendarRender_handler(aEvent) {
        if (mRenderHandler) {
            mRenderHandler(aEvent);
        }
    }
    function specialEventHandler(aStart, aEnd,aEvent) {
        var lDefault = { start: aStart, end: aEnd ,jsEvent:aEvent};

        if (mSpecialLayout) {
            lDefault = mSpecialLayout(aStart, aEnd,aEvent);
        }
        return lDefault;
    }

    function calendar_handleClick(aEvent, aElement) {
        if (mClickHandler) {
            mClickHandler(aEvent, aElement);
        }
    }

    function calendar_handleRightClick(aEvent, aElement) {
        if (mRightClickHandler) {
            mRightClickHandler(aEvent, aElement);
        }
    }

    function calendar_handleAfterRender(aEvent, aElement) {
        if (mAfterRenderHandler) {
            mAfterRenderHandler(aEvent, aElement);
        }
    }

    function calendar_handleAfterAllRender() {
        if (mAfterAllRenderHandler) {
            mAfterAllRenderHandler();
        }
    }

    function calendar_handleViewRender(aView) {
        if (mViewRenderHandler) {
            mViewRenderHandler(aView);
        }
    }

    function calendar_handleEditMode() {
        if (mViewEditMode) {
            mViewEditMode();
        }
    }

    function calendar_handleSelect(aStart, aEnd, aIndex, aReocurring, aPopup) {
        if (mViewSelect) {
            mViewSelect(aStart, aEnd, aIndex, aReocurring, aPopup);
        }
    }

    this.calendarId = function () {
        return calendarId;
    }

    function cal_eventResized(event, delta, revertFunc, jsEvent) {
        mEditType = 0;
        mEditingSchedule = event;

        if (mResized) {
            mResized(event, jsEvent, revertFunc);
        }
    }

    function cal_eventResizeStop(event, jsEvent, ui, view) {
        mEditType = 0;
        mEditingSchedule = event;

        if (mResizeOver) {
            mResizeOver(event);
        }
    }

    function disableCalendarNavigation(aVal) {
        if (mDisableNavigation) {
            mDisableNavigation(aVal);
        }
    }

    function cal_eventDragStop(event, dayDelta, minuteDelta, allDay, revertFunc) {
        if (mViewDragStop) {
            mViewDragStop(event, dayDelta, minuteDelta, allDay, revertFunc);
        } else {
            mEditType = 1;
            mEditingSchedule = event;
        }       
    }

    function cal_eventDrop(event, delta, revertFunc, jsEvent, ui, view) {
        if (mViewDragDrop) {
            mViewDragDrop(event, delta, revertFunc, jsEvent, ui, view);
        }       
    }

    function colorInverter(aDoThis, colorClass) {
        var colorInvert = 'ColorInvert';

        if (colorClass) {
            colorInvert = colorClass;
        }
        if (aDoThis) {
            $('.fc-unthemed tbody').addClass(colorInvert);
        } else {
            $('.fc-unthemed tbody').removeClass(colorInvert);
        }
        invertColorsSet = aDoThis;
        invertColorsClass = colorInvert;
    }

    function firstDay() {

    }

    this.getEditingSchedule = function () {
        return mEditingSchedule;
    }

    this.setEditingSchedule = function (aEdit) {
        mEditingSchedule = aEdit;
    }

    function setData(aDataSource) {
        $(aId).fullCalendar('addEventSource', aDataSource);
        $(aId).fullCalendar('rerenderEvents');
    }

    this.resetData = function () {
        var lView = $(aId).fullCalendar('getView');
        calendar_handleViewRender(lView);
    }

    this.updateEvent = function (aEvent) {
        $(aId).fullCalendar('updateEvent', aEvent);
    }

    this.setDataSource = function (aDataSource) {

        var lView = $(aId).fullCalendar('getView');
        if (!isNullOrUndefined(aDataSource)) {
            $(aId).fullCalendar('removeEvents');
            mDataSource = aDataSource;
            calendar_handleViewRender(lView);
        }
    }

    this.getDataSource = function () {
        return mDataSource || [];
    }

    this.getRawDataSource = function () {
        return $(aId).fullCalendar('clientEvents');
    }

    this.destroy = function () {
        $(aId).fullCalendar('destroy');
    }

    this.setHandlers = function (aHandlers) {
        mClickHandler = aHandlers.clickHandler;
        mViewRenderHandler = aHandlers.viewRender;
        mAfterRenderHandler = aHandlers.afterRender;
        mAfterAllRenderHandler = aHandlers.afterAllRender;
        mViewEditMode = aHandlers.editMode;
        mViewSelect = aHandlers.selected;
        mViewDragDrop = aHandlers.eventDrop;
        mViewDragStop = aHandlers.eventDragStop;
        mViewEvents = aHandlers.events;
        mNewSelectEvents = aHandlers.newSelect;
        mSpecialLayout = aHandlers.specialEventLayout;
        mRenderHandler = aHandlers.renderHandler;
        mResizeOver = aHandlers.resizeOver;
        mResized = aHandlers.resized;
    }

    this.deleteHandlers = function () {
        mClickHandler = null;
        mViewRenderHandler = null;
        mAfterRenderHandler = null;
        mAfterAllRenderHandler = null;
        mViewEditMode = null;
        mViewSelect = null;
        mViewDragDrop = null;
        mViewDragStop = null; 
        mViewEvents = null;
        mNewSelectEvents = null; 
        mSpecialLayout = null;
        mRenderHandler = null;
        mResizeOver = null;
        mResized = null;
    }
    // update to wrapper for carve out mode
    this.invertDayColors = function (aDoThis, colorClass) {
        colorInverter(aDoThis, colorClass);
    }

    this.lockSaveMode = function (aLocked) {
        //lockSave = true;
    }

    this.addExtraData = function (aVal, aData) {
        extraData[aVal] = aData;
    }

    this.getExtraData = function (aVal) {
        return extraData[aVal];
    }

    this.getViewName = function () {
        return $(aId).fullCalendar('getView').name;
    }
    this.disableView = function (viewName) {
        if ($(aId).fullCalendar('getView').name === viewName) {
            $(aId).fullCalendar('changeView', 'agendaWeek'); // change later.
        }
        $(".fc-" + viewName + "-button").addClass("fc-state-disabled").attr("disabled", "disabled")
    }

    this.enableView = function (viewName) {
        $(".fc-" + viewName + "-button").removeClass("fc-state-disabled").removeAttr("disabled");
    }

    this.setView = function (viewName) {
        var lViewName = viewName;

        if (!viewName)
            lViewName = $(aId).fullCalendar('getView').name;

        $(aId).fullCalendar('changeView', lViewName);
    }

    this.updateFullCalendarOptions = function (optionName, value) {
        $(aId).fullCalendar('getView').calendar.optionsModel._props[optionName] = value;
    }
};